"use strict";

Shopify.theme.jsSlideshowWithText = {
  createSlider: function createSlider() {
    var slideshowWithText = $('.slideshow-with-text__gallery');
    var $carousel = $(slideshowWithText).flickity({
      lazyLoad: 2,
      fade: true,
      freeScroll: false,
      imagesLoaded: true,
      setGallerySize: false,
      draggable: true,
      cellAlign: 'left',
      wrapAround: false,
      pageDots: false,
      contain: false,
      prevNextButtons: true,
      on: {
        ready: function ready() {
          // Resize flickity when the slider is settled
          $(slideshowWithText).on('settle.flickity', function () {
            $(slideshowWithText).flickity('resize');
          });
        },
        change: function(index) {
          console.log("CHANGE", index)
          $('[data-slideshow-with-text-current-slide]').text(index + 1);
        }
      }
    });

    $('[data-slideshow-with-text-previous]').off('click').on('click', function() {
        $carousel.flickity('previous');
    });
    $('[data-slideshow-with-text-next]').off('click').on('click', function() {
        $carousel.flickity('next');
    });
      
  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
};

$(document).ready(function() {
  Shopify.theme.jsSlideshowWithText.createSlider();
  //Shopify.theme.jsSlideshowWithText.customControls();
})